<template>
  <div class="pickedStaff">
    <van-nav-bar :title="subHead" left-arrow @click-left="goBack" />
    <van-cell-group :title="`内部用餐人：${list.length}人`">
      <van-cell
        v-for="(item) in list"
        :key="item.id"
        clickable
      >
        <template #title>
          <div class="title">
            <svg-icon icon-class="staff_avatar" style="font-size: 0.35rem" />
            <div class="value">
              <div class="name">
                <div>{{ item.personName }}</div>
              </div>
            </div>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>

export default {
  name: 'ShowStaff',
  data() {
    return {
      list: [],
      subHead: ''
    };
  },
  created() {
    const { title, list } = this.$route.query;
    this.subHead = title;
    this.list = JSON.parse(list);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.pickedStaff {
  .header {
    height: 0.44rem;
    font-size: 0.17rem;
    font-weight: 400;
    line-height: 0.24rem;
    color: #333333;
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.135rem;
    .confirm {
      color: #3B86FF;
    }
  }
  .title {
    display: flex;
    align-items: center;
    .value {
      display: flex;
      flex-direction: column;
      margin-left: 0.08rem;
      .name {
        font-size: 0.17rem;
        font-weight: 400;
        //line-height: 0.24rem;
        color: #001833;
        display: flex;
        align-items: center;

        .sign {
          background: rgba(80, 196, 79, 0.1);
          border: 1px solid #50C44F;
          opacity: 1;
          border-radius: 27px;
          font-size: 0.08rem;
          height: 0.15rem;
          font-family: PingFang SC;
          color: #50C44F;
          margin-left: 0.1rem;
          padding: 0 0.07rem;
          display: flex;
          align-items: center;
        }
      }
      .department {
        font-size: 0.14rem;
        font-weight: 400;
        line-height: 0.2rem;
        color: #333333;
      }

    }
  }
}
</style>
